import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EventTypes, PublicEventsService } from 'angular-auth-oidc-client';
import { filter } from 'rxjs';
import { SessionRefreshService } from './session-refresh.service';

// PBI-866415 / PBI-877361: escucha los eventos internos de
// angular-auth-oidc-client y solo fuerza /login cuando la renovación
// silenciosa ha fallado de verdad.
//
// TokenExpired / IdTokenExpired se ignoran a propósito: la librería los emite
// en cada comprobación periódica (cada 4s) en cuanto el token entra en la
// ventana de renovación, justo antes de renovarlo ella misma. Lanzar aquí otra
// renovación duplicaba la petición al IDP y, al encontrarse una en curso,
// devolvía "no autenticado" y mandaba al usuario a /login.
@Injectable({ providedIn: 'root' })
export class AuthEventsService {
  private readonly eventsService = inject(PublicEventsService);
  private readonly sessionRefreshService = inject(SessionRefreshService);
  private readonly router = inject(Router);
  private initialized = false;

  init(): void {
    if (this.initialized) return;
    this.initialized = true;

    this.eventsService
      .registerForEvents()
      .pipe(filter((n) => !!n))
      .subscribe((notification) => {
        switch (notification.type) {
          case EventTypes.NewAuthenticationResult: {
            const result = notification.value as {
              validationResult?: string;
              isAuthenticated?: boolean;
            };
            if (
              result &&
              !result.isAuthenticated &&
              result.validationResult &&
              result.validationResult !== 'Ok'
            ) {
              console.error('[AUTH] Token rechazado por la validación OIDC', {
                validationResult: result.validationResult,
              });
            }
            break;
          }

          case EventTypes.SilentRenewFailed:
            console.error(
              '[AUTH] Falló la renovación silenciosa de la sesión',
              notification.value,
            );
            this.tryRefreshOrReauth('SilentRenewFailed');
            break;
        }
      });
  }

  private tryRefreshOrReauth(reason: string): void {
    // Último intento con el refresh_token (compartido con el interceptor y el
    // guard) antes de mandar al usuario a /login.
    this.sessionRefreshService.refresh(reason).subscribe((renewed) => {
      if (!renewed) {
        this.forceReauth();
      }
    });
  }

  private forceReauth(): void {
    localStorage.setItem('sessionExpired', 'true');
    if (this.router.url && this.router.url !== '/login') {
      sessionStorage.setItem('redirectUrl', this.router.url);
    }
    this.router.navigate(['login']);
  }
}